/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Auth_LoginRequest } from '../models/Auth_LoginRequest';
import type { Auth_LoginResponse } from '../models/Auth_LoginResponse';
import type { Auth_LogoutResponse } from '../models/Auth_LogoutResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
  /**
   * Login operation
   * Login...
   * @param requestBody The new Auth resource
   * @returns Auth_LoginResponse Auth resource created
   * @throws ApiError
   */
  public static login(
    requestBody: Auth_LoginRequest
  ): CancelablePromise<Auth_LoginResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid input`,
        422: `Unprocessable entity`,
      },
    });
  }
  /**
   * Logout operation
   * Logout...
   * @param token The new Auth resource
   * @returns Auth_LogoutResponse Auth resource
   * @throws ApiError
   */
  public static logout(token: string): CancelablePromise<Auth_LogoutResponse> {
    if (token === null || token === undefined) {
      throw new Error(
        'Required parameter token was null or undefined when calling logout.'
      );
    }

    return __request(OpenAPI, {
      method: 'GET',
      url: '/logout',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      errors: {
        404: `Resource not found`,
      },
    });
  }
}
